// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Quotation_upper__oJrcy {
  display: grid;
  grid-template-columns: 72rem 1.5fr;
  gap: 2rem;
}
@media only screen and (max-width: 62.5em) {
  .Quotation_upper__oJrcy {
    grid-template-columns: 60rem 1fr;
  }
}
@media only screen and (max-width: 56.25em) {
  .Quotation_upper__oJrcy {
    grid-template-columns: 100%;
  }
}
.Quotation_upper__ql__1kBEX {
  width: 100%;
  border-radius: 2rem;
  background-color: var(--color-white);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  padding: 3.5rem 2rem;
  height: fit-content;
  align-self: center;
}
@media only screen and (max-width: 56.25em) {
  .Quotation_upper__ql__1kBEX {
    width: 95%;
    justify-self: center;
  }
}
.Quotation_upper__ql__content__VyePU {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  box-sizing: border-box;
  gap: 2rem;
  margin-top: 3rem;
}
.Quotation_upper__multiple__fzfNT {
  display: flex;
  flex-direction: column;
  border-radius: 2rem;
  background-color: var(--color-white);
  padding: 2rem;
}
.Quotation_upper__metrics__WS\\+Tj {
  box-sizing: border-box;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-bottom: 1rem;
}
@media only screen and (max-width: 62.5em) {
  .Quotation_upper__metrics__WS\\+Tj {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media only screen and (max-width: 56.25em) {
  .Quotation_upper__metrics__WS\\+Tj {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media only screen and (max-width: 37.5em) {
  .Quotation_upper__metrics__WS\\+Tj {
    grid-template-columns: repeat(2, 1fr);
  }
}
.Quotation_upper__metrics_paid__zJUy8 {
  background-color: var(--color-green);
  color: var(--color-white);
}
.Quotation_upper__metrics_unpaid__GUZWM {
  background-color: var(--color-error);
  color: var(--color-white);
}
.Quotation_upper__metrics_partPaid__F9m5r {
  background-color: var(--color-yellow);
}
.Quotation_upper__metrics_vat__F7284 {
  background-color: var(--color-light-red);
}
.Quotation_upper__metrics_discount__GAUIH {
  background-color: var(--color-primary-7);
}
.Quotation_upper__metrics_due__G2i2r {
  background-color: var(--color-error);
  color: var(--color-white);
}
.Quotation_upper__metrics_owe__hHo3U {
  background-color: var(--color-error);
  color: var(--color-white);
}

.Quotation_searchInMiddle__R0Pc3 {
  display: flex;
  width: 100%;
  justify-content: center;
}

.Quotation_invoice__list__NKEix {
  margin-top: 2rem;
  display: flex;
  position: relative;
}
.Quotation_invoice__beside__WwzGg {
  display: flex;
  justify-content: space-between;
  width: 38rem;
  flex-wrap: wrap;
}
.Quotation_invoice__checks__ETmaX {
  display: flex;
  justify-content: space-between;
  margin: 1rem 0 2rem 0;
  width: 100%;
}
.Quotation_invoice__checks_group__ykDZP {
  align-self: center;
  width: 100%;
}

.Quotation_table__iWuay {
  width: 100%;
  max-width: 100%;
  border: none;
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: left;
  font-size: var(--default-font-small);
}
.Quotation_table__iWuay th,
.Quotation_table__iWuay td {
  padding: 2.2rem 0;
}
.Quotation_table__iWuay th {
  font-weight: 700;
}
.Quotation_table__iWuay tr {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 7rem 1fr 1fr;
  padding: 0 3rem;
}
@media only screen and (max-width: 37.5em) {
  .Quotation_table__iWuay tr {
    grid-template-columns: 20% 50% 30%;
  }
}
.Quotation_table__iWuay tbody > :not(:last-child) {
  margin-bottom: 1.5rem;
}
.Quotation_table__iWuay tbody tr {
  background-color: var(--color-primary-3);
  border-radius: 1.3rem;
}
.Quotation_table__iWuay tbody tr:nth-child(even) {
  background-color: var(--color-primary-7);
}
.Quotation_table__iWuay tbody tr > :last-child {
  display: flex;
  justify-content: space-between;
  font-size: var(--default-font-size);
}
@media only screen and (max-width: 37.5em) {
  .Quotation_table__iWuay tbody tr > :last-child {
    font-size: var(--default-font-small);
  }
}
.Quotation_table__iWuay tbody tr > :last-child > * {
  cursor: pointer;
}
.Quotation_table__iWuay tbody tr > :last-child > *:hover {
  color: var(--color-primary);
}
.Quotation_table__iWuay tbody tr > :nth-child(5) {
  font-size: 3rem;
  position: relative;
}
.Quotation_table__iWuay tbody tr > :nth-child(5) span {
  font-size: 1.2rem;
  width: fit-content;
  background-color: rgba(0, 0, 0, 0.75);
  color: var(--color-white);
  position: absolute;
  padding: 0.5rem;
  left: -1.6rem;
  border-radius: 0.5rem;
  text-align: center;
  opacity: 0;
  cursor: pointer;
}
.Quotation_table__iWuay tbody tr > :nth-child(5) span:hover {
  opacity: 1;
}

.Quotation_notPaid__vCoV1 {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-error);
  color: var(--color-white);
  margin-bottom: 1rem;
  width: 83%;
  position: relative;
  top: 1rem;
}

.Quotation_partPaid__YSfdR {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-yellow);
  color: var(--color-dark);
  margin-bottom: 1rem;
  width: 83%;
}

.Quotation_paid__uMnTG {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-green);
  color: var(--color-white);
  margin-bottom: 1rem;
  width: 83%;
}

.Quotation_minMenu__ZF8Z1 {
  color: var(--color-primary);
  cursor: pointer;
  font-size: 2rem;
}

.Quotation_sideButton__JWh\\+J {
  display: flex;
  margin-top: 3rem;
}

.Quotation_summary__hqyBR {
  width: 42rem;
  margin-top: 2rem;
}
.Quotation_summary__title__7IsmR {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Quotation_summary__initials__qLBVg {
  display: flex;
  background-color: var(--color-primary-7);
  font-size: var(--default-font-h3);
  font-weight: 700;
  width: 8rem;
  height: 8rem;
  border-radius: 8rem;
  justify-content: center;
  align-items: center;
}
.Quotation_summary__edit__FmZvx {
  display: flex;
  align-items: flex-end;
  color: var(--color-dark);
  font-size: var(--default-font-small);
  cursor: pointer;
  margin-bottom: 3rem;
}
.Quotation_summary__edit__FmZvx > :last-child {
  font-size: 3rem;
  color: var(--color-primary);
}
.Quotation_summary__edit__FmZvx:hover, .Quotation_summary__edit__FmZvx:focus {
  color: var(--color-primary-4);
  font-weight: 700;
}
.Quotation_summary__line__2J0mQ {
  border-top: 1px solid var(--color-dark);
  margin: 2rem 0;
}
.Quotation_summary__dates__2nEZG {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
}
.Quotation_summary__dates__2nEZG > :not(:last-child) {
  margin-right: 2rem;
}
.Quotation_summary__total__bNg2T {
  display: grid;
  grid-template-columns: 1.3fr 1fr;
  gap: 2rem;
  margin-bottom: 1rem;
}
.Quotation_summary__account__da\\+kO {
  display: grid;
  grid-template-columns: 1.3fr 1fr;
  gap: 1rem;
  margin: 2rem 0;
}
.Quotation_summary__button__UDSW3 {
  display: flex;
  gap: 2rem;
  align-items: center;
  margin-top: 2rem;
}

.Quotation_error__fVsCZ {
  font-size: var(--default-font-small);
  color: var(--color-error);
  padding-left: 2rem;
  font-weight: 400;
  margin: 1rem 0;
}

.Quotation_select__im3E1 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  box-sizing: border-box;
  font-size: var(--default-font-small);
  width: 38rem;
  margin-bottom: 3rem;
  cursor: pointer;
}
.Quotation_select__im3E1 > * {
  padding: 1rem 0 1rem 0;
  text-align: center;
}
.Quotation_select__invoice__luZrh {
  background-color: var(--color-primary);
  color: var(--color-white);
  border-radius: 1rem 0 0 1rem;
  transition: all 0.4s;
}
.Quotation_select__invoice_b__S69J7 {
  border: 1px solid var(--color-primary);
  border-radius: 1rem 0 0 1rem;
  transition: all 0.4s;
}
.Quotation_select__receipt__rqDAp {
  border: 1px solid var(--color-primary);
  border-radius: 0 1rem 1rem 0;
  transition: all 0.4s;
}
.Quotation_select__receipt_b__ndxFq {
  background-color: var(--color-primary);
  color: var(--color-white);
  border-radius: 0 1rem 1rem 0;
  transition: all 0.4s;
}

.Quotation_selectCurrency__sTMD4 {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: var(--default-font-small);
  position: relative;
  margin-left: 2rem;
}
.Quotation_selectCurrency__text__lnNI5 {
  display: flex;
  margin-left: 1rem;
}
.Quotation_selectCurrency__icon__2YZTt {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  background-color: #f2f0f0;
  color: var(--color-primary);
  width: 5rem;
  height: 5rem;
  border-radius: 5rem;
  border: solid 1px var(--color-primary-4);
  cursor: pointer;
  transform: rotateZ(0);
  transition-duration: 500ms;
}
.Quotation_selectCurrency__icon__2YZTt:hover {
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  background-color: var(--color-primary-3);
  transform: rotateZ(-180deg);
}
.Quotation_selectCurrency__icon_active__2pExs {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  background-color: #f2f0f0;
  color: var(--color-primary);
  width: 5rem;
  height: 5rem;
  border-radius: 5rem;
  border: solid 1px var(--color-primary-4);
  cursor: pointer;
  transition-duration: 500ms;
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  background-color: var(--color-primary-3);
  transform: rotateZ(-180deg);
}
.Quotation_selectCurrency__list__aceSd {
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  width: 5rem;
  background-color: #f2f0f0;
  color: var(--color-dark);
  border-radius: 1rem;
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  position: absolute;
  top: 6rem;
  z-index: 30;
  border: solid 1px var(--color-primary-4);
}
.Quotation_selectCurrency__list_active__UqGLB {
  background-color: var(--color-primary-7);
  color: var(--color-primary);
  font-weight: 700;
}
.Quotation_selectCurrency__list__aceSd li {
  list-style: none;
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 1rem 0;
  box-sizing: border-box;
  border-radius: 1rem;
  cursor: pointer;
}
.Quotation_selectCurrency__list__aceSd li:hover {
  background-color: var(--color-primary-7);
  color: var(--color-primary);
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Quotation/Quotation.module.scss"],"names":[],"mappings":"AAEA;EACC,aAAA;EACA,kCAAA;EACA,SAAA;AADD;AAGC;EALD;IAME,gCAAA;EAAA;AACF;AAEC;EATD;IAUE,2BAAA;EACA;AACF;AAOC;EACC,WAAA;EACA,mBAAA;EACA,oCAAA;EACA,4CAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;AALF;AAOE;EAVD;IAWE,UAAA;IACA,oBAAA;EAJD;AACF;AAME;EACC,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAJH;AAQC;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,oCAAA;EACA,aAAA;AANF;AASC;EACC,sBAAA;EACA,WAAA;EACA,aAAA;EACA,qCAAA;EACA,SAAA;EACA,mBAAA;AAPF;AASE;EARD;IASE,qCAAA;EAND;AACF;AAQE;EAZD;IAaE,qCAAA;EALD;AACF;AAOE;EAhBD;IAiBE,qCAAA;EAJD;AACF;AAME;EACC,oCAAA;EACA,yBAAA;AAJH;AAOE;EACC,oCAAA;EACA,yBAAA;AALH;AAQE;EACC,qCAAA;AANH;AASE;EACC,wCAAA;AAPH;AAUE;EACC,wCAAA;AARH;AAWE;EACC,oCAAA;EACA,yBAAA;AATH;AAYE;EACC,oCAAA;EACA,yBAAA;AAVH;;AAeA;EACC,aAAA;EACA,WAAA;EACA,uBAAA;AAZD;;AAgBC;EACC,gBAAA;EACA,aAAA;EACA,kBAAA;AAbF;AAgBC;EACC,aAAA;EACA,8BAAA;EACA,YAAA;EACA,eAAA;AAdF;AAiBC;EACC,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,WAAA;AAfF;AAiBE;EACC,kBAAA;EACA,WAAA;AAfH;;AAiCA;EACC,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,oCAAA;AA9BD;AAgCC;;EAEC,iBAAA;AA9BF;AAiCC;EACC,gBAAA;AA/BF;AAkCC;EACC,aAAA;EACA,mDAAA;EACA,eAAA;AAhCF;AAkCE;EALD;IAME,kCAAA;EA/BD;AACF;AAmCE;EACC,qBAAA;AAjCH;AAoCE;EACC,wCAAA;EACA,qBAAA;AAlCH;AAoCG;EACC,wCAAA;AAlCJ;AAqCG;EACC,aAAA;EACA,8BAAA;EACA,mCAAA;AAnCJ;AAoCI;EAJD;IAKE,oCAAA;EAjCH;AACF;AAmCI;EACC,eAAA;AAjCL;AAkCK;EACC,2BAAA;AAhCN;AAqCG;EAWC,eAAA;EACA,kBAAA;AA7CJ;AA+CI;EACC,iBAAA;EACA,kBAAA;EACA,qCAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;AA7CL;AA+CK;EACC,UAAA;AA7CN;;AAqDA;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,oCAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;AAlDD;;AAqDA;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,qCAAA;EACA,wBAAA;EACA,mBAAA;EACA,UAAA;AAlDD;;AAqDA;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,oCAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;AAlDD;;AAqDA;EACC,2BAAA;EACA,eAAA;EACA,eAAA;AAlDD;;AAsDA;EACC,aAAA;EACA,gBAAA;AAnDD;;AAuDA;EACC,YAAA;EACA,gBAAA;AApDD;AAqDC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AAnDF;AAsDC;EACC,aAAA;EACA,wCAAA;EACA,iCAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AApDF;AAuDC;EACC,aAAA;EACA,qBAAA;EACA,wBAAA;EACA,oCAAA;EACA,eAAA;EACA,mBAAA;AArDF;AAuDE;EACC,eAAA;EACA,2BAAA;AArDH;AAwDE;EAEC,6BAAA;EACA,gBAAA;AAvDH;AA2DC;EACC,uCAAA;EACA,cAAA;AAzDF;AA4DC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AA1DF;AA2DE;EACC,kBAAA;AAzDH;AA6DC;EACC,aAAA;EACA,gCAAA;EACA,SAAA;EACA,mBAAA;AA3DF;AA8DC;EACC,aAAA;EACA,gCAAA;EACA,SAAA;EACA,cAAA;AA5DF;AA+DC;EACC,aAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;AA7DF;;AAmEA;EACC,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAhED;;AAmEA;EACC,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,oCAAA;EACA,YAAA;EAEA,mBAAA;EACA,eAAA;AAjED;AAmEC;EACC,sBAAA;EACA,kBAAA;AAjEF;AAoEC;EACC,sCAAA;EACA,yBAAA;EACA,4BAAA;EACA,oBAAA;AAlEF;AAoEE;EACC,sCAAA;EACA,4BAAA;EACA,oBAAA;AAlEH;AAsEC;EACC,sCAAA;EACA,4BAAA;EACA,oBAAA;AApEF;AAsEE;EACC,sCAAA;EACA,yBAAA;EACA,4BAAA;EACA,oBAAA;AApEH;;AAyEA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,iBAAA;AAtED;AAwEC;EACC,aAAA;EACA,iBAAA;AAtEF;AAyEC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,eAAA;EACA,qBAAA;EACA,0BAAA;AAvEF;AAyEE;EACC,4DACC;EAED,wCAAA;EACA,2BAAA;AAzEH;AA4EE;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,eAAA;EACA,0BAAA;EACA,4DACC;EAED,wCAAA;EACA,2BAAA;AA5EH;AAgFC;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,yBAAA;EACA,wBAAA;EACA,mBAAA;EACA,4DACC;EAED,kBAAA;EACA,SAAA;EACA,WAAA;EACA,wCAAA;AAhFF;AAkFE;EACC,wCAAA;EACA,2BAAA;EACA,gBAAA;AAhFH;AAmFE;EACC,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AAjFH;AAmFG;EACC,wCAAA;EACA,2BAAA;EACA,gBAAA;AAjFJ","sourcesContent":["@import '../variables/breakpoints';\n\n.upper {\n\tdisplay: grid;\n\tgrid-template-columns: 72rem 1.5fr;\n\tgap: 2rem;\n\n\t@media only screen and (max-width: $bp-1000) {\n\t\tgrid-template-columns: 60rem 1fr;\n\t}\n\n\t@media only screen and (max-width: $bp-900) {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t// &__search {\n\t// \tgrid-column: 1/3;\n\t// \tgrid-row: 1/2;\n\t// \tjustify-self: center;\n\t// }\n\n\t&__ql {\n\t\twidth: 100%;\n\t\tborder-radius: 2rem;\n\t\tbackground-color: var(--color-white);\n\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\t\tbox-sizing: border-box;\n\t\tpadding: 3.5rem 2rem;\n\t\theight: fit-content;\n\t\talign-self: center;\n\n\t\t@media only screen and (max-width: $bp-900) {\n\t\t\twidth: 95%;\n\t\t\tjustify-self: center;\n\t\t}\n\n\t\t&__content {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tjustify-content: space-evenly;\n\t\t\tbox-sizing: border-box;\n\t\t\tgap: 2rem;\n\t\t\tmargin-top: 3rem;\n\t\t}\n\t}\n\n\t&__multiple {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tborder-radius: 2rem;\n\t\tbackground-color: var(--color-white);\n\t\tpadding: 2rem;\n\t}\n\n\t&__metrics {\n\t\tbox-sizing: border-box;\n\t\twidth: 100%;\n\t\tdisplay: grid;\n\t\tgrid-template-columns: repeat(3, 1fr);\n\t\tgap: 2rem;\n\t\tmargin-bottom: 1rem;\n\n\t\t@media only screen and (max-width: $bp-1000) {\n\t\t\tgrid-template-columns: repeat(2, 1fr);\n\t\t}\n\n\t\t@media only screen and (max-width: $bp-900) {\n\t\t\tgrid-template-columns: repeat(3, 1fr);\n\t\t}\n\n\t\t@media only screen and (max-width: $bp-600) {\n\t\t\tgrid-template-columns: repeat(2, 1fr);\n\t\t}\n\n\t\t&_paid {\n\t\t\tbackground-color: var(--color-green);\n\t\t\tcolor: var(--color-white);\n\t\t}\n\n\t\t&_unpaid {\n\t\t\tbackground-color: var(--color-error);\n\t\t\tcolor: var(--color-white);\n\t\t}\n\n\t\t&_partPaid {\n\t\t\tbackground-color: var(--color-yellow);\n\t\t}\n\n\t\t&_vat {\n\t\t\tbackground-color: var(--color-light-red);\n\t\t}\n\n\t\t&_discount {\n\t\t\tbackground-color: var(--color-primary-7);\n\t\t}\n\n\t\t&_due {\n\t\t\tbackground-color: var(--color-error);\n\t\t\tcolor: var(--color-white);\n\t\t}\n\n\t\t&_owe {\n\t\t\tbackground-color: var(--color-error);\n\t\t\tcolor: var(--color-white);\n\t\t}\n\t}\n}\n\n.searchInMiddle {\n\tdisplay: flex;\n\twidth: 100%;\n\tjustify-content: center;\n}\n\n.invoice {\n\t&__list {\n\t\tmargin-top: 2rem;\n\t\tdisplay: flex;\n\t\tposition: relative;\n\t}\n\n\t&__beside {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\twidth: 38rem;\n\t\tflex-wrap: wrap;\n\t}\n\n\t&__checks {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tmargin: 1rem 0 2rem 0;\n\t\twidth: 100%;\n\n\t\t&_group {\n\t\t\talign-self: center;\n\t\t\twidth: 100%;\n\t\t}\n\t}\n}\n\n// .status {\n// \tcontent: none;\n// \twidth: 50%;\n// \tborder-radius: 1rem;\n// \tbackground-color: var(--color-yellow);\n// \tjustify-self: center;\n// \talign-self: center;\n// \tpadding: 3rem;\n// \tdisplay: block;\n// }\n\n//Table styles start\n\n.table {\n\twidth: 100%;\n\tmax-width: 100%;\n\tborder: none;\n\tborder-collapse: collapse;\n\tbox-sizing: border-box;\n\ttext-align: left;\n\tfont-size: var(--default-font-small);\n\n\tth,\n\ttd {\n\t\tpadding: 2.2rem 0;\n\t}\n\n\tth {\n\t\tfont-weight: 700;\n\t}\n\n\ttr {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 1fr 1fr 1fr 1fr 7rem 1fr 1fr;\n\t\tpadding: 0 3rem;\n\n\t\t@media only screen and (max-width: $bp-600) {\n\t\t\tgrid-template-columns: 20% 50% 30%;\n\t\t}\n\t}\n\n\ttbody {\n\t\t& > :not(:last-child) {\n\t\t\tmargin-bottom: 1.5rem;\n\t\t}\n\n\t\ttr {\n\t\t\tbackground-color: var(--color-primary-3);\n\t\t\tborder-radius: 1.3rem;\n\n\t\t\t&:nth-child(even) {\n\t\t\t\tbackground-color: var(--color-primary-7);\n\t\t\t}\n\n\t\t\t& > :last-child {\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\tfont-size: var(--default-font-size);\n\t\t\t\t@media only screen and (max-width: $bp-600) {\n\t\t\t\t\tfont-size: var(--default-font-small);\n\t\t\t\t}\n\n\t\t\t\t& > * {\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tcolor: var(--color-primary);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t& > :nth-child(5) {\n\t\t\t\t// content: none;\n\t\t\t\t// width: 3rem;\n\t\t\t\t// height: 3rem;\n\t\t\t\t// border-radius: 0.8rem;\n\n\t\t\t\t// justify-self: center;\n\t\t\t\t// align-self: center;\n\t\t\t\t// padding: 0;\n\t\t\t\t// margin-left: -2rem;\n\n\t\t\t\tfont-size: 3rem;\n\t\t\t\tposition: relative;\n\n\t\t\t\tspan {\n\t\t\t\t\tfont-size: 1.2rem;\n\t\t\t\t\twidth: fit-content;\n\t\t\t\t\tbackground-color: rgba(0, 0, 0, 0.75);\n\t\t\t\t\tcolor: var(--color-white);\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tpadding: 0.5rem;\n\t\t\t\t\tleft: -1.6rem;\n\t\t\t\t\tborder-radius: 0.5rem;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\topacity: 0;\n\t\t\t\t\tcursor: pointer;\n\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\topacity: 1;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.notPaid {\n\tdisplay: inline-flex;\n\tjustify-content: center;\n\tline-height: 1;\n\tfont-size: 1rem;\n\tborder-radius: 1rem;\n\tbackground-color: var(--color-error);\n\tcolor: var(--color-white);\n\tmargin-bottom: 1rem;\n\twidth: 83%;\n\tposition: relative;\n\ttop: 1rem;\n}\n\n.partPaid {\n\tdisplay: inline-flex;\n\tjustify-content: center;\n\tline-height: 1;\n\tfont-size: 1rem;\n\tborder-radius: 1rem;\n\tbackground-color: var(--color-yellow);\n\tcolor: var(--color-dark);\n\tmargin-bottom: 1rem;\n\twidth: 83%;\n}\n\n.paid {\n\tdisplay: inline-flex;\n\tjustify-content: center;\n\tline-height: 1;\n\tfont-size: 1rem;\n\tborder-radius: 1rem;\n\tbackground-color: var(--color-green);\n\tcolor: var(--color-white);\n\tmargin-bottom: 1rem;\n\twidth: 83%;\n}\n\n.minMenu {\n\tcolor: var(--color-primary);\n\tcursor: pointer;\n\tfont-size: 2rem;\n}\n//Table styles end\n\n.sideButton {\n\tdisplay: flex;\n\tmargin-top: 3rem;\n}\n\n//Summary Styles\n.summary {\n\twidth: 42rem;\n\tmargin-top: 2rem;\n\t&__title {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t}\n\n\t&__initials {\n\t\tdisplay: flex;\n\t\tbackground-color: var(--color-primary-7);\n\t\tfont-size: var(--default-font-h3);\n\t\tfont-weight: 700;\n\t\twidth: 8rem;\n\t\theight: 8rem;\n\t\tborder-radius: 8rem;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t}\n\n\t&__edit {\n\t\tdisplay: flex;\n\t\talign-items: flex-end;\n\t\tcolor: var(--color-dark);\n\t\tfont-size: var(--default-font-small);\n\t\tcursor: pointer;\n\t\tmargin-bottom: 3rem;\n\n\t\t& > :last-child {\n\t\t\tfont-size: 3rem;\n\t\t\tcolor: var(--color-primary);\n\t\t}\n\n\t\t&:hover,\n\t\t&:focus {\n\t\t\tcolor: var(--color-primary-4);\n\t\t\tfont-weight: 700;\n\t\t}\n\t}\n\n\t&__line {\n\t\tborder-top: 1px solid var(--color-dark);\n\t\tmargin: 2rem 0;\n\t}\n\n\t&__dates {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tmargin-bottom: 2rem;\n\t\t& > :not(:last-child) {\n\t\t\tmargin-right: 2rem;\n\t\t}\n\t}\n\n\t&__total {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 1.3fr 1fr;\n\t\tgap: 2rem;\n\t\tmargin-bottom: 1rem;\n\t}\n\n\t&__account {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 1.3fr 1fr;\n\t\tgap: 1rem;\n\t\tmargin: 2rem 0;\n\t}\n\n\t&__button {\n\t\tdisplay: flex;\n\t\tgap: 2rem;\n\t\talign-items: center;\n\t\tmargin-top: 2rem;\n\t}\n}\n\n//Errors\n\n.error {\n\tfont-size: var(--default-font-small);\n\tcolor: var(--color-error);\n\tpadding-left: 2rem;\n\tfont-weight: 400;\n\tmargin: 1rem 0;\n}\n\n.select {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr;\n\tbox-sizing: border-box;\n\tfont-size: var(--default-font-small);\n\twidth: 38rem;\n\n\tmargin-bottom: 3rem;\n\tcursor: pointer;\n\n\t& > * {\n\t\tpadding: 1rem 0 1rem 0;\n\t\ttext-align: center;\n\t}\n\n\t&__invoice {\n\t\tbackground-color: var(--color-primary);\n\t\tcolor: var(--color-white);\n\t\tborder-radius: 1rem 0 0 1rem;\n\t\ttransition: all 0.4s;\n\n\t\t&_b {\n\t\t\tborder: 1px solid var(--color-primary);\n\t\t\tborder-radius: 1rem 0 0 1rem;\n\t\t\ttransition: all 0.4s;\n\t\t}\n\t}\n\n\t&__receipt {\n\t\tborder: 1px solid var(--color-primary);\n\t\tborder-radius: 0 1rem 1rem 0;\n\t\ttransition: all 0.4s;\n\n\t\t&_b {\n\t\t\tbackground-color: var(--color-primary);\n\t\t\tcolor: var(--color-white);\n\t\t\tborder-radius: 0 1rem 1rem 0;\n\t\t\ttransition: all 0.4s;\n\t\t}\n\t}\n}\n\n.selectCurrency {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tfont-size: var(--default-font-small);\n\tposition: relative;\n\tmargin-left: 2rem;\n\n\t&__text {\n\t\tdisplay: flex;\n\t\tmargin-left: 1rem;\n\t}\n\n\t&__icon {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tfont-size: 3rem;\n\t\tbackground-color: #f2f0f0;\n\t\tcolor: var(--color-primary);\n\t\twidth: 5rem;\n\t\theight: 5rem;\n\t\tborder-radius: 5rem;\n\t\tborder: solid 1px var(--color-primary-4);\n\t\tcursor: pointer;\n\t\ttransform: rotateZ(0);\n\t\ttransition-duration: 500ms;\n\n\t\t&:hover {\n\t\t\tbox-shadow:\n\t\t\t\t10px 10px 45px #bebebe,\n\t\t\t\t-15px -15px 30px #ffffff;\n\t\t\tbackground-color: var(--color-primary-3);\n\t\t\ttransform: rotateZ(-180deg);\n\t\t}\n\n\t\t&_active {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tfont-size: 3rem;\n\t\t\tbackground-color: #f2f0f0;\n\t\t\tcolor: var(--color-primary);\n\t\t\twidth: 5rem;\n\t\t\theight: 5rem;\n\t\t\tborder-radius: 5rem;\n\t\t\tborder: solid 1px var(--color-primary-4);\n\t\t\tcursor: pointer;\n\t\t\ttransition-duration: 500ms;\n\t\t\tbox-shadow:\n\t\t\t\t10px 10px 45px #bebebe,\n\t\t\t\t-15px -15px 30px #ffffff;\n\t\t\tbackground-color: var(--color-primary-3);\n\t\t\ttransform: rotateZ(-180deg);\n\t\t}\n\t}\n\n\t&__list {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tbox-sizing: border-box;\n\t\twidth: 5rem;\n\t\tbackground-color: #f2f0f0;\n\t\tcolor: var(--color-dark);\n\t\tborder-radius: 1rem;\n\t\tbox-shadow:\n\t\t\t10px 10px 45px #bebebe,\n\t\t\t-15px -15px 30px #ffffff;\n\t\tposition: absolute;\n\t\ttop: 6rem;\n\t\tz-index: 30;\n\t\tborder: solid 1px var(--color-primary-4);\n\n\t\t&_active {\n\t\t\tbackground-color: var(--color-primary-7);\n\t\t\tcolor: var(--color-primary);\n\t\t\tfont-weight: 700;\n\t\t}\n\n\t\tli {\n\t\t\tlist-style: none;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\twidth: 100%;\n\t\t\tpadding: 1rem 0;\n\t\t\tbox-sizing: border-box;\n\t\t\tborder-radius: 1rem;\n\t\t\tcursor: pointer;\n\n\t\t\t&:hover {\n\t\t\t\tbackground-color: var(--color-primary-7);\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t\tfont-weight: 700;\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"upper": `Quotation_upper__oJrcy`,
	"upper__ql": `Quotation_upper__ql__1kBEX`,
	"upper__ql__content": `Quotation_upper__ql__content__VyePU`,
	"upper__multiple": `Quotation_upper__multiple__fzfNT`,
	"upper__metrics": `Quotation_upper__metrics__WS+Tj`,
	"upper__metrics_paid": `Quotation_upper__metrics_paid__zJUy8`,
	"upper__metrics_unpaid": `Quotation_upper__metrics_unpaid__GUZWM`,
	"upper__metrics_partPaid": `Quotation_upper__metrics_partPaid__F9m5r`,
	"upper__metrics_vat": `Quotation_upper__metrics_vat__F7284`,
	"upper__metrics_discount": `Quotation_upper__metrics_discount__GAUIH`,
	"upper__metrics_due": `Quotation_upper__metrics_due__G2i2r`,
	"upper__metrics_owe": `Quotation_upper__metrics_owe__hHo3U`,
	"searchInMiddle": `Quotation_searchInMiddle__R0Pc3`,
	"invoice__list": `Quotation_invoice__list__NKEix`,
	"invoice__beside": `Quotation_invoice__beside__WwzGg`,
	"invoice__checks": `Quotation_invoice__checks__ETmaX`,
	"invoice__checks_group": `Quotation_invoice__checks_group__ykDZP`,
	"table": `Quotation_table__iWuay`,
	"notPaid": `Quotation_notPaid__vCoV1`,
	"partPaid": `Quotation_partPaid__YSfdR`,
	"paid": `Quotation_paid__uMnTG`,
	"minMenu": `Quotation_minMenu__ZF8Z1`,
	"sideButton": `Quotation_sideButton__JWh+J`,
	"summary": `Quotation_summary__hqyBR`,
	"summary__title": `Quotation_summary__title__7IsmR`,
	"summary__initials": `Quotation_summary__initials__qLBVg`,
	"summary__edit": `Quotation_summary__edit__FmZvx`,
	"summary__line": `Quotation_summary__line__2J0mQ`,
	"summary__dates": `Quotation_summary__dates__2nEZG`,
	"summary__total": `Quotation_summary__total__bNg2T`,
	"summary__account": `Quotation_summary__account__da+kO`,
	"summary__button": `Quotation_summary__button__UDSW3`,
	"error": `Quotation_error__fVsCZ`,
	"select": `Quotation_select__im3E1`,
	"select__invoice": `Quotation_select__invoice__luZrh`,
	"select__invoice_b": `Quotation_select__invoice_b__S69J7`,
	"select__receipt": `Quotation_select__receipt__rqDAp`,
	"select__receipt_b": `Quotation_select__receipt_b__ndxFq`,
	"selectCurrency": `Quotation_selectCurrency__sTMD4`,
	"selectCurrency__text": `Quotation_selectCurrency__text__lnNI5`,
	"selectCurrency__icon": `Quotation_selectCurrency__icon__2YZTt`,
	"selectCurrency__icon_active": `Quotation_selectCurrency__icon_active__2pExs`,
	"selectCurrency__list": `Quotation_selectCurrency__list__aceSd`,
	"selectCurrency__list_active": `Quotation_selectCurrency__list_active__UqGLB`
};
export default ___CSS_LOADER_EXPORT___;
